import { Rating } from "./rating";

export class RatingObject implements Rating {
  rate: number;
  rated: boolean;
  timestamp: string;
  user_uuid:string;
}
